import { Upload } from "@aws-sdk/lib-storage";
import { AbortMultipartUploadCommandOutput, CompleteMultipartUploadCommand, CompleteMultipartUploadCommandOutput, S3Client } from "@aws-sdk/client-s3";
import { XhrHttpHandler } from "@aws-sdk/xhr-http-handler";
//import prettyBytes from "pretty-bytes";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import {  fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";

export interface FileUploaderConfig {

    region: string,
    identityPoolId: string,
    bucketId: string,
    bucketPath?: string

}

export interface ProgressData {
    percentage: number,
    uploaded: number,
    total: number
}

export enum UploadEventType {
    STARTED = "uploadStarted",
    ERROR = "uploadError",
    COMPLETED = "uploadCompleted"
}

export interface UploadCompletedData {
    s3FilePath: string,
    uploadTime: number
}

export interface UploadErrorData {
    error: string,
    requestId?: string,
    statusCode?: number
}

export type UploadEventData = UploadCompletedData

export interface UploadEvent {
    filename: string,
    eventType: UploadEventType,
    data?: UploadEventData | UploadErrorData
}

export type ProgressListener = (p: ProgressData) => void
export type UploadEventListener = (p: UploadEvent) => void

export interface UploadListeners {

    progress?: ProgressListener,
    started?: UploadEventListener,
    completed?: UploadEventListener,
    error?: UploadEventListener

}


export type UploadAbortFunction = () => Promise<void>

export class S3AnonymousFileUploader {


    private s3int: S3Client;
    private cognito: CognitoIdentityClient;
    private alreadyInit: boolean;

    constructor(private config: FileUploaderConfig) {
        this.alreadyInit = false;
       
    }


    private getS3Client(): S3Client {
        if(!this.alreadyInit) {

            this.alreadyInit = true;
            this.cognito = new CognitoIdentityClient({region: this.config.region});
            this.s3int = new S3Client({
                region: this.config.region,
                credentials: fromCognitoIdentityPool({
                    client: this.cognito,
                    identityPoolId:  this.config.identityPoolId, // IDENTITY_POOL_ID                  
                }),
                requestHandler: new XhrHttpHandler({})
            });
            
        }
        else {
            console.log("FileUploader already init");
            
        }
        return this.s3int;
    }


    public upload(files: FileList,eventListener?: UploadListeners,fileNameTransformer: (name: string,ext: string) => string = (a,b) => a + (b?"." + b:"")): UploadAbortFunction {
        if(files && files.length > 0) {
            const file = files[0];
            const splitten = file.name.split(".");
            const ext = splitten.pop();
            const named = splitten.join(".");
            const fileName = fileNameTransformer(named,ext);
            const uploadParams = {
                Bucket: this.config.bucketId,
                Key: (this.config.bucketPath?this.config.bucketPath:"") + "/" + fileName,
                Body: file
            }
            const s3 = this.getS3Client();
            const upload = new Upload({
                client: s3,
                params: uploadParams
            });
            if(eventListener.started) {
                eventListener.started({
                    filename: fileName,
                    eventType: UploadEventType.STARTED,
                });
            }
            const startTimestamp = new Date().getTime()
            if(eventListener) {
                if(eventListener.progress) {
                    upload.on("httpUploadProgress", prog => {
                        const percentage = Math.min(Math.floor(prog.loaded * 100/ prog.total),100);
                        eventListener.progress({
                            percentage: percentage,
                            uploaded: prog.loaded,
                            total: prog.total
                        });
                    });
                }
                if(eventListener.error || eventListener.completed) {
                    upload.done().then(res => {
                        if(res.$metadata.httpStatusCode == 200) {
                            if(eventListener.completed) {
                                const asCompletedEvent = res as CompleteMultipartUploadCommandOutput;
                                eventListener.completed({
                                    filename: fileName,
                                    eventType: UploadEventType.COMPLETED,
                                    data: {
                                        uploadTime: new Date().getTime() - startTimestamp,
                                        s3FilePath: asCompletedEvent.Location?asCompletedEvent.Location:""
                                    }
                                })
                            }
                        }
                        else {
                            if(eventListener.error) {
                                const asErrorEvent = res as AbortMultipartUploadCommandOutput;
                                eventListener.error({
                                    filename: fileName,
                                    eventType: UploadEventType.ERROR,
                                    data: {
                                        error: "ErrorDuringUpload",
                                        statusCode: asErrorEvent.$metadata.httpStatusCode,
                                        requestId: asErrorEvent.$metadata.requestId
                                    }
                                })
                            }
                        }
                    });
                }
            }

            return () => {
                return upload.abort();
            };
        }
    }
}
